export default "__VITE_PUBLIC_ASSET__3ca729ef__"